// Цвет подписи и иконок поверх эмали цвета игрока (дизайн-система матча,
// см. src/styles/gameUi/tokens.css). Цвет игрока любой — от желтого до почти
// черного нейтрала, — поэтому подпись выбирается не по таблице, а по контрасту:
// какая из двух дает больший контраст по WCAG, та и берется

export const GAME_UI_DARK_INK = '#23170a';
export const GAME_UI_LIGHT_INK = '#fffaf0';

const parseHexColor = (hex) => {
  const value = String(hex).trim().replace('#', '');
  const full = value.length === 3 ? value.split('').map((c) => c + c).join('') : value;
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
};

/**
 * Относительная яркость цвета по WCAG 2
 * @param {string} hex - '#rrggbb' или '#rgb'
 * @returns {number} 0..1
 */
export const getRelativeLuminance = (hex) => {
  const [r, g, b] = parseHexColor(hex).map((channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/**
 * Контраст двух цветов по WCAG 2: от 1 (одинаковые) до 21 (черный на белом)
 * @param {string} a
 * @param {string} b
 * @returns {number}
 */
export const getContrastRatio = (a, b) => {
  const la = getRelativeLuminance(a);
  const lb = getRelativeLuminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
};

/**
 * Темная или светлая подпись — та, что контрастнее с фоном
 * @param {string} backgroundHex - цвет фона, '#rrggbb'
 * @returns {string} GAME_UI_DARK_INK или GAME_UI_LIGHT_INK
 */
export const getReadableInkColor = (backgroundHex) => (
  getContrastRatio(backgroundHex, GAME_UI_DARK_INK) >= getContrastRatio(backgroundHex, GAME_UI_LIGHT_INK)
    ? GAME_UI_DARK_INK
    : GAME_UI_LIGHT_INK
);
